import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useBidIncrementsInBidPanel = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.BidIncrementsInBidPanel,
        AmplitudeVariants.BidIncrementsInBidPanel.Treatment
    );
